export default "__VITE_ASSET__DO8oTmXk__"